import React from "react";
import QuizBeta from "./QuizBeta";


export const QuizBetaArchive = () => (<QuizBeta isArchive={true}/>);

export default QuizBetaArchive;
